import { render, staticRenderFns } from "./Kr1RirekishoEdit.vue?vue&type=template&id=5d3f61ed&scoped=true&"
import script from "./Kr1RirekishoEdit.vue?vue&type=script&lang=js&"
export * from "./Kr1RirekishoEdit.vue?vue&type=script&lang=js&"
import style0 from "./Kr1RirekishoEdit.vue?vue&type=style&index=0&id=5d3f61ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3f61ed",
  null
  
)

export default component.exports